var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPajamasCheck = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_40_688)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.2 5.95333L6.58667 4.33333H10.3333V6.66667H11.3333V3.33333H6.58667L8.2 1.71333L7.49333 1L4.66667 3.83333L7.49333 6.66667L8.2 5.95333ZM8 9.33333C7.60444 9.33333 7.21776 9.45063 6.88886 9.67039C6.55996 9.89016 6.30362 10.2025 6.15224 10.568C6.00087 10.9334 5.96126 11.3356 6.03843 11.7235C6.1156 12.1115 6.30608 12.4678 6.58579 12.7475C6.86549 13.0273 7.22186 13.2177 7.60982 13.2949C7.99778 13.3721 8.39991 13.3325 8.76537 13.1811C9.13082 13.0297 9.44318 12.7734 9.66294 12.4445C9.8827 12.1156 10 11.7289 10 11.3333C10 10.8029 9.78929 10.2942 9.41421 9.91912C9.03914 9.54405 8.53043 9.33333 8 9.33333ZM2 7.33333V15.3333H14V7.33333M12.6667 12.6667C12.313 12.6667 11.9739 12.8071 11.7239 13.0572C11.4738 13.3072 11.3333 13.6464 11.3333 14H4.66667C4.66667 13.6464 4.52619 13.3072 4.27614 13.0572C4.02609 12.8071 3.68696 12.6667 3.33333 12.6667V10C3.68696 10 4.02609 9.85952 4.27614 9.60948C4.52619 9.35943 4.66667 9.02029 4.66667 8.66667H11.3333C11.3333 9.02029 11.4738 9.35943 11.7239 9.60948C11.9739 9.85952 12.313 10 12.6667 10V12.6667Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_40_688"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPajamasCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_pajamas_check.41016c03.svg";
export { ForwardRef as ReactComponent };